import { ConfigContext } from "../config"
import { useContext } from "preact/hooks"

/**
 * Preact hook that import current config to the component.
 *
 * **Should always be at the top of the component!**
 *
 * @example
 * ```jsx
 * import { useConfig } from '@nosto/preact'
 *
 * export default () => {
 *     const { serpPath } = useConfig()
 *
 *     return <div>
 *         Default search page path {serpPath}
 *     </div>
 * }
 * ```
 *
 * @group Hooks
 */
export function useConfig() {
    return useContext(ConfigContext)
}
